import React from 'react';
import { useTheme } from '@stashinvest/ui';

const BankCard = () => {
	const { colors } = useTheme();
	return (
		<svg
			width="30"
			height="24"
			viewBox="0 0 30 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M0.251295 9.39589C-0.192035 7.43507 1.03814 5.48612 2.99896 5.04279L22.8408 0.556669C24.8017 0.113339 26.7506 1.34351 27.1939 3.30434L29.7487 14.6041C30.1921 16.5649 28.9619 18.5139 27.0011 18.9572L7.15921 23.4433C5.19838 23.8867 3.24943 22.6565 2.8061 20.6957L0.251295 9.39589ZM3.32975 6.50586C2.17696 6.7665 1.45373 7.91231 1.71437 9.0651L4.26917 20.3649C4.52981 21.5177 5.67562 22.2409 6.82842 21.9803L26.6703 17.4942C27.8231 17.2335 28.5463 16.0877 28.2857 14.9349L25.7309 3.63513C25.4702 2.48233 24.3244 1.7591 23.1716 2.01974L3.32975 6.50586Z"
				fill={colors.iconDefault}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M26.3799 14.8501C26.4709 15.2542 26.2171 15.6555 25.813 15.7466L20.0011 17.0558C19.597 17.1468 19.1957 16.893 19.1046 16.489C19.0136 16.0849 19.2674 15.6835 19.6715 15.5925L25.4834 14.2832C25.8875 14.1922 26.2889 14.446 26.3799 14.8501Z"
				fill={colors.iconDefault}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M25.8224 12.3902C25.9138 12.7942 25.6604 13.1958 25.2564 13.2872L21.541 14.1276C21.137 14.219 20.7354 13.9655 20.644 13.5615C20.5526 13.1575 20.806 12.7559 21.2101 12.6645L24.9254 11.8242C25.3294 11.7328 25.731 11.9862 25.8224 12.3902Z"
				fill={colors.iconDefault}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4.66824 13.0342C4.47337 12.1723 5.01411 11.3156 5.87601 11.1207L8.35085 10.5612C9.21275 10.3663 10.0694 10.9071 10.2643 11.769L10.8238 14.2438C11.0187 15.1057 10.478 15.9624 9.61608 16.1573L7.14124 16.7168C6.27934 16.9117 5.42266 16.3709 5.22779 15.509L4.66824 13.0342ZM6.2068 12.5838C6.15293 12.596 6.11913 12.6495 6.13131 12.7034L6.69086 15.1782C6.70304 15.2321 6.75658 15.2659 6.81045 15.2537L9.28529 14.6942C9.33916 14.682 9.37295 14.6285 9.36077 14.5746L8.80123 12.0998C8.78905 12.0459 8.73551 12.0121 8.68164 12.0243L6.2068 12.5838Z"
				fill={colors.iconDefault}
			/>
		</svg>
	);
};

export default BankCard;
